export interface IRouteLocation {
    pathname: string;
    search?: string;
    hash?: string;
}

export const getCanonicalLocationPath = (location: IRouteLocation): string =>
    `${location.pathname.replace(/\/$/, "")}${location.search || ""}${location.hash || ""}`;
